export default __webpack_public_path__ + "bc45fdf51f76e46f022fc7ffa92f6228.png";